export default "<p>delovna works!</p>\n";